import { useState } from "react";
import {
  resolveServiceImageSrc,
  SERVICE_IMAGE_FALLBACK,
} from "../../utils/serviceImage";

type Props = {
  src?: unknown;
  alt: string;
  className?: string;
  loading?: "lazy" | "eager";
};

const ServiceThumbnail = ({
  src,
  alt,
  className,
  loading = "lazy",
}: Props) => {
  const [failed, setFailed] = useState(false);
  const resolved = failed ? SERVICE_IMAGE_FALLBACK : resolveServiceImageSrc(src);
  const isFallback = resolved === SERVICE_IMAGE_FALLBACK;

  return (
    <img
      className={[
        "ac-service-thumbnail",
        isFallback ? "ac-service-thumbnail--fallback" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      src={resolved}
      alt={alt}
      loading={loading}
      decoding="async"
      onError={() => setFailed(true)}
    />
  );
};

export default ServiceThumbnail;
